import { render, staticRenderFns } from "./impersonate-popup.vue?vue&type=template&id=6a2f71b4&scoped=true&"
import script from "./impersonate-popup.ts?vue&type=script&lang=ts&"
export * from "./impersonate-popup.ts?vue&type=script&lang=ts&"
import style0 from "./impersonate-popup.scss?vue&type=style&index=0&id=6a2f71b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f71b4",
  null
  
)

export default component.exports